import React from 'react';
import PropTypes from 'prop-types';
import { Location } from 'history';
import { defaultUpdateLocation } from '../update_params';

export interface LocationWithHash extends Partial<Location> {
  hash?: string;
}

export type UpdateUrlType = (
  currentLocation: Location,
  params: PlainObject,
  anchor?: string,
) => Partial<LocationWithHash>;

export interface IUpdateURLProps {
  updateUrl: UpdateUrlType;
}

export function getContextType() {
  return {
    updateUrl: PropTypes.func,
  };
}

export class UpdateURLProvider extends React.Component<IUpdateURLProps, {}>
  implements React.ChildContextProvider<IUpdateURLProps> {

  static childContextTypes = getContextType();

  getChildContext() {
    return { updateUrl: this.props.updateUrl };
  }

  render() {
    return <div>{this.props.children}</div>;
  }
}

export function withUpdateURL<TProps extends {}>(
  Component: React.ComponentType<TProps & IUpdateURLProps>,
): React.ComponentType<TProps> {

  const result = class Connected extends React.Component<TProps, null> {
    static displayName = `withUpdateURL(${Component.displayName || Component.name})`;

    static WrappedComponent = Component;

    static contextTypes = getContextType();

    render() {
      const updateUrl = this.context.updateUrl || defaultUpdateLocation;

      return (<Component updateUrl={updateUrl} {...this.props} />);
    }
  };

  return result;
}
